// <head> кабинета репетитора /{lang}/tutors/me: noindex, без canonical и
// hreflang (в sitemap его нет), стили формы. no-referrer: страница закрытая,
// её адрес и данные не должны уходить в Referer сторонним скриптам (Google Maps, Turnstile).
import tjCss from "./tutor-join.css?url";
import tmCss from "./tutors-map.css?url";
import { CABINET_COPY } from "./cabinet-copy";
import type { SiteLang } from "@/components/site/SiteChrome";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";

/** title — свой заголовок вкладки (экраны «Готово!» и «Изменить анкету»); по умолчанию — кабинет. */
export function tutorCabinetHead(lang: SiteLang, title?: string) {
  return {
    meta: [
      { title: title ? `${title} — Yolutap` : CABINET_COPY[lang].metaTitle },
      { name: "robots", content: "noindex, nofollow" },
      { name: "referrer", content: "no-referrer" },
    ],
    links: [...SITE_CHROME_LINKS, { rel: "stylesheet", href: tjCss }, { rel: "stylesheet", href: tmCss }],
  };
}
